module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("All Because of Daisy")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#introduction"
    }
  }, [_vm._v("Introduction")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#love-at-first-sight"
    }
  }, [_vm._v("1 – Love at First Sight")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#a-bridge-over-the-shannon"
    }
  }, [_vm._v("2 – A Bridge over the Shannon")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-turning-point",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 – The Turning Point")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#going-home-to-wales",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 – Going Home to Wales")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#ireland-beckons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 – Ireland Beckons")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#life-in-knockadrehid-the-early-days",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 – Life in Knockadrehid: The Early Days")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#christy-storan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 – Christy Storan")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#crottys-field",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 – Crotty’s Field")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#this-sporting-life",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 – This Sporting Life")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#john-and-mary-crotty",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 – John and Mary Crotty")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#doing-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 – Doing Time")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#the-city-with-a-beating-heart",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 – The City with a Beating Heart")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#today-and-tomorrow",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 – Today and Tomorrow")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#all-because-of-daisy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 – All Because of Daisy")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0